import ajax from '@/api/ajax.js'
import { AUTH_NAME } from '@/utils/constants.js'
/**
 * 请求配置列表
 * @method
 * @param {Object}
 * @return {Object} 返回值 包括code,msg,result
 */
export const getConfigList = ({ page, pageSize }) =>
  ajax(
    AUTH_NAME.systemConfig.list,
    {
      page,
      pageSize
    },
    'POST'
  )
/**
 * @method
 * @return {Object} 返回值 包括code,msg,result
 * @param {Integer} id
 * @param {Integer} status
 */
export const reqConfigStatus = ({ id, status }) =>
  ajax(
    AUTH_NAME.systemConfig.changeStatus,
    {
      id,
      status
    },
    'POST'
  )
/**
 * @method 编辑配置
 * @return {Object} 返回值 包括code,msg,result
 * @param {Integer} id
 * @param {Integer} type
 */
export const reqEditConfig = ({
  id,
  name,
  content,
  type,
  reportTypes,
  reportDescriptions,
  uploadNum,
  uploadSize,
  picUploadNum,
  feedback,
  invited,
  limitCount,
  settings
}) =>
  ajax(
    AUTH_NAME.systemConfig.edit,
    {
      id,
      name,
      content,
      type,
      reportTypes,
      reportDescriptions,
      uploadNum,
      uploadSize,
      picUploadNum,
      feedback,
      invited,
      limitCount,
      settings
    },
    'POST'
  )
